import React from 'react';

const Frame = ({ children, className }) => <div className={`frame ${className ?? ''}`.trim()}>{children}</div>;

export default Frame;
